module.exports = __webpack_public_path__ + "static/img/item-5-1-big.ffde361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-5-1-big.jpg
// module id = g6/L
// module chunks = 2